@let KEY_PREFIX = 'shop-settings.subscription.plans.confirmation-modal.';

<app-base-modal [title]="KEY_PREFIX + 'title' | translate">
  <p class="change-warning margin-zero">
    {{ KEY_PREFIX + 'text.' + (isDowngrade() ? 'downgrade' : 'upgrade') | translate }}
  </p>
  <app-modal-controls
    [primaryActionTextKey]="KEY_PREFIX + 'actions.change'"
    [secondaryActionTextKey]="KEY_PREFIX + 'actions.cancel'"
    (secondaryActionTriggered)="close()"
    (primaryActionTriggered)="proceed()"
  />
</app-base-modal>
